module.exports = __webpack_public_path__ + "img/106ne.2db6a112.svg";